import { communitySetEditMode } from "../../../../actions/community-actions"

import buildViewFormActionButtonsWidgetContainer from "../../../common/build-view-form-action-buttons-widget-container"

export default buildViewFormActionButtonsWidgetContainer(
    communitySetEditMode,
    "communities",
    "is_manager"
)
